'use client';

import LinkIcon from './Link.js';
import HistoryIcon from './History.js';
import FavoriteIcon from './Favorite.js';
import UnFavoriteIcon from './UnFavorite.js';
import ProductDocumentsIcon from './ProductDocuments.js';
import StarIcon from './Star.js';

var Misc = {
    LinkIcon: LinkIcon,
    HistoryIcon: HistoryIcon,
    FavoriteIcon: FavoriteIcon,
    UnFavoriteIcon: UnFavoriteIcon,
    ProductDocumentsIcon: ProductDocumentsIcon,
    StarIcon: StarIcon
};

export { Misc as default };
//# sourceMappingURL=index.js.map
